import { Outlet, Link } from "react-router-dom"
import { useState } from "react"
import "./css/footerbox.css"
import Footer from "./footer"
import linkname from "./linkname.jsx";

const FooterBox = () => {
    // State for mobile floating menu
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const Top = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        // Close menu on mobile after clicking a link
        setIsMenuOpen(false);
    }

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    }

    return (
        <div className="footerBoxWrapper">
            
            {/* Mobile Menu Toggle Button (Visible only on mobile/tablet) */}
            <button className="mobileMenuToggleBtn" onClick={toggleMenu}>
                <i className={`fa-solid ${isMenuOpen ? 'fa-xmark' : 'fa-list-ul'}`}></i>
                <span>Quick Links</span>
            </button>

            {/* Overlay for mobile when menu is open */}
            {isMenuOpen && <div className="mobileMenuOverlay" onClick={() => setIsMenuOpen(false)}></div>}

            <div className="footerBoxMainContainer">
                
                {/* Sidebar Menu (Static on Desktop, Floating on Mobile) */}
                <div className={`footerBoxLinkMainContainer ${isMenuOpen ? 'showMobileMenu' : ''}`}>
                    <div className="FooterboxLinkContainer">
                        <div className="menuTitleMobile">Menu</div>
                        <Link to="/footer/features" onClick={Top}>
                            <i className="fa-solid fa-star"></i> {linkname.features}
                        </Link>
                        <Link to="/footer/about" onClick={Top}>
                            <i className="fa-solid fa-info-circle"></i> {linkname.about}
                        </Link>
                        <Link to="/footer/contact" onClick={Top}>
                            <i className="fa-solid fa-envelope"></i> {linkname.contact}
                        </Link>
                        <Link to="/footer/help" onClick={Top}>
                            <i className="fa-solid fa-question-circle"></i> {linkname.helpcenter}
                        </Link>
                        <Link to="/footer/policy" onClick={Top}>
                            <i className="fa-solid fa-shield-alt"></i> {linkname.policy}
                        </Link>
                        <Link to="/footer/conditions" onClick={Top}>
                            <i className="fa-solid fa-file-contract"></i> {linkname.conditions}
                        </Link>
                        <Link to="/footer/cookies" onClick={Top}>
                            <i className="fa-solid fa-file-contract"></i> {linkname.cookies}
                        </Link>
                        <Link to="/footer/guidelines" onClick={Top}>
                            <i className="fa-solid fa-users"></i> {linkname.guidelines}
                        </Link>
                        <Link to="/footer/guide" onClick={Top}>
                            <i className="fa-solid fa-book-open"></i> {linkname.guide}
                        </Link>
                        <Link to="/footer/manual" onClick={Top}>
                            <i className="fa-solid fa-book"></i> {linkname.manual}
                        </Link>
                    </div>
                </div>

                {/* Main content */}
                <div className="footerBoxOutletContainer">
                    <Outlet/>
                </div>
            </div>
            
            <div className="footerBoxFooterWrapper">
                <Footer />
            </div>
        </div>
    )
}

export default FooterBox